import { ActivityTargetView } from "@sp-crm/core";

const cadenceNounByUnit: Record<string, string> = {
    Daily: "day",
    Weekly: "week",
    Monthly: "month",
};

export const describeCadence = (intervalCount: number, intervalUnit: string): string => {
    const noun = cadenceNounByUnit[intervalUnit] ?? intervalUnit.toLowerCase();
    return intervalCount === 1 ? `every ${noun}` : `every ${intervalCount} ${noun}s`;
};

export interface TouchpointStatusView {
    state: "due" | "satisfied" | "snoozed";
    pendingVisit: "scheduled" | "awaitingOutcome" | null;
    lastContactedAt: string | null;
    nextDueAt: string | null;
}

export const touchpointStatusLabel = (status: TouchpointStatusView): string => {
    if (status.state === "snoozed") {
        return "Snoozed";
    }
    if (status.state === "satisfied") {
        if (status.pendingVisit === "scheduled") {
            return "Visit scheduled";
        }
        if (status.pendingVisit === "awaitingOutcome") {
            return "Visit awaiting outcome";
        }
        const completed = status.lastContactedAt
            ? `Completed ${new Date(status.lastContactedAt).toLocaleDateString()}`
            : "Completed";
        return status.nextDueAt
            ? `${completed} · next due ${new Date(status.nextDueAt).toLocaleDateString()}`
            : completed;
    }
    return status.lastContactedAt
        ? `Last completed ${new Date(status.lastContactedAt).toLocaleDateString()}`
        : "Not yet completed";
};

export const describeTargets = (targets: ActivityTargetView[]): string => {
    const labels = targets.map(target => target.label);
    if (labels.length <= 1) {
        return labels[0] ?? "";
    }
    return `${labels.slice(0, -1).join(", ")} or ${labels[labels.length - 1]}`;
};
